import type { JSX } from 'react'

import { PrimarySubmitButton } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"
import { TextBlock, TextBlockDirection, TextBlockRowGap } from "/app/libraries/arcana/src/blocks/TextBlock/index.ts"
import { TextBoxCaption3, TextBoxHeadline3 } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { useUnit } from 'effector-react'
import { translations } from '../model'

LockedBlock.displayName = 'LockedBlock'
export function LockedBlock(): JSX.Element {
  const { title, message, text, buttonText } = useUnit(
    translations.$waitingEmailConfirmationTranslations
  )

  return (
    <>
      <TextBoxHeadline3 title={title} />
      <TextBlock
        direction={TextBlockDirection.COLUMN}
        rowGap={TextBlockRowGap.INDENT_50}
      >
        <TextBoxCaption3 title={message} />
        <TextBoxCaption3 title={text} />
        <PrimarySubmitButton isLoading withLoader title={buttonText} />
      </TextBlock>
    </>
  )
}
